"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackSuccessPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FeedbackSuccessPanel, _Component);

  function FeedbackSuccessPanel() {
    (0, _classCallCheck3.default)(this, FeedbackSuccessPanel);
    return (0, _possibleConstructorReturn3.default)(this, (FeedbackSuccessPanel.__proto__ || (0, _getPrototypeOf2.default)(FeedbackSuccessPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeedbackSuccessPanel, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetState();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12 text-center" },
        _react2.default.createElement("i", { className: "icon-mp-ok create-ad-success-icon" }),
        _react2.default.createElement(
          "div",
          { className: "col-xs-8 col-xs-offset-2" },
          _react2.default.createElement(
            "h1",
            { className: "h3 title-js" },
            _react2.default.createElement(
              "p",
              null,
              "Palautteen l\xE4hett\xE4minen onnistui!"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col-xs-12" },
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              "b",
              null,
              "Kiitos palautteestasi! Meihin voi olla my\xF6s suoraan yhteydess\xE4, tietomme l\xF6ytyv\xE4t yhteystiedot v\xE4lilehdelt\xE4."
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-sm-6" },
              _react2.default.createElement(_Button2.default, {
                text: "Etusivulle",
                onClick: this.handleHomeButtonClick.bind(this)
              })
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-sm-6" },
              _react2.default.createElement(_Button2.default, {
                text: "Yhteystiedot",
                additionalClasses: "button-inverse",
                onClick: this.handleContactInfoButtonClick.bind(this)
              })
            )
          )
        )
      );
    }
  }, {
    key: "handleHomeButtonClick",
    value: function handleHomeButtonClick() {
      this.props.resetState();
      this.props.pushRoute("/");
    }
  }, {
    key: "handleContactInfoButtonClick",
    value: function handleContactInfoButtonClick() {
      this.props.resetState();
      this.props.pushRoute("/yhteystiedot");
    }
  }]);
  return FeedbackSuccessPanel;
}(_react.Component), _class.propTypes = {
  pushRoute: _react.PropTypes.func.isRequired,
  resetState: _react.PropTypes.func.isRequired,
  feedback: _react.PropTypes.func
}, _temp);
exports.default = FeedbackSuccessPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/feedback/FeedbackSuccessPanel.js
 ** module id = 1150
 ** module chunks = 0
 **/